// Títulos dos controles nativos do Mapbox (tooltip dos botões).
export const MAPBOX_LOCALE_PT = {
  'NavigationControl.ZoomIn': 'Aumentar zoom',
  'NavigationControl.ZoomOut': 'Diminuir zoom',
  'NavigationControl.ResetBearing': 'Redefinir orientação para o norte',
}
